/**
 * Product Page Promo - MaisonHousse
 * Applique les mêmes promos (prix barrés) que sur les pages collection.
 * Même formule que card-product.liquid et custom-cart-drawer.js.
 *
 * ANTI-GLITCH: patches renderProductInfo to modify fetched HTML
 * BEFORE it is injected into the DOM, so the browser never renders
 * an unpromo'd price.
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  /* ── PROMO CALCULATION ── */
  function calculatePromo(productId, priceInCents) {
    var promoEuros = (productId % 15) + 20;
    if (promoEuros > 35) promoEuros = 35;
    var promoMaxCents = Math.floor(priceInCents * 45 / 55);
    var promoCents = promoEuros * 100;
    if (promoCents > promoMaxCents) promoCents = promoMaxCents;
    return promoCents;
  }

  /* ── PRICE FORMATTING ── */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u20AC';
  }

  /* ── FETCH PRODUCT DATA ── */
  var productHandle = window.location.pathname.split('/products/')[1]
    .split('?')[0].split('#')[0].replace(/\/$/, '');
  var productData = null;

  function fetchProductData() {
    return fetch('/products/' + productHandle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { productData = data; return data; });
  }

  /* ── GET CURRENT VARIANT ── */
  function getVariantById(variantId) {
    if (!productData) return null;
    if (variantId) {
      var found = productData.variants.find(function (v) {
        return v.id === parseInt(variantId, 10);
      });
      if (found) return found;
    }
    return productData.variants[0];
  }

  function getCurrentVariant() {
    if (!productData) return null;
    var variantId = new URLSearchParams(window.location.search).get('variant');
    if (!variantId) {
      var input = document.querySelector('input[name="id"], .product-variant-id');
      if (input) variantId = input.value;
    }
    return getVariantById(variantId);
  }

  /* ── APPLY PROMO TO A PRICE CONTAINER (DOM element) ── */
  function applyPromoToContainer(container, currentPrice, fakeComparePrice, promoEuros) {
    container.setAttribute('data-ccd-promo', 'done');
    container.classList.add('price--on-sale', 'price--show-badge');

    var regularDiv = container.querySelector('.price__regular');
    var saleDiv = container.querySelector('.price__sale');

    if (regularDiv) {
      regularDiv.style.cssText = 'display:none!important';
    }
    if (saleDiv) {
      saleDiv.style.cssText = 'display:flex!important;align-items:center;gap:8px;flex-wrap:wrap';
      saleDiv.innerHTML =
        '<span><s class="price-item price-item--regular" style="color:#999;font-size:0.9em">' +
          formatMoney(fakeComparePrice) +
        '</s></span>' +
        '<span class="price-item price-item--sale price-item--last" style="color:#000;font-weight:600">' +
          formatMoney(currentPrice) +
        '</span>';
    }

    var badge = container.querySelector('.price__badge-sale, .lm-badge');
    if (badge) {
      badge.style.cssText = 'display:inline-block!important';
      badge.innerHTML = '<strong>\u00C9conomiser ' + promoEuros + '\u20AC</strong>';
    }
  }

  /* ── APPLY PROMO TO ALL VISIBLE PRICE CONTAINERS ── */
  function applyPromo() {
    if (!productData) return;
    var variant = getCurrentVariant();
    if (!variant) return;

    var currentPrice = variant.price;
    var promoCents = calculatePromo(productData.id, currentPrice);
    if (promoCents <= 0) return;

    var fakeComparePrice = currentPrice + promoCents;
    var promoEuros = Math.floor(promoCents / 100);

    var containers = document.querySelectorAll('[id^="price-"] .price');
    if (!containers.length) containers = document.querySelectorAll('.price.lumin-price');

    containers.forEach(function (c) {
      if (c.getAttribute('data-ccd-promo') === 'done') return;
      applyPromoToContainer(c, currentPrice, fakeComparePrice, promoEuros);
    });
  }

  /* ── APPLY PROMO TO PARSED HTML (before DOM injection) ── */
  function applyPromoToHtml(htmlDoc, sectionId, variantId) {
    var variant = getVariantById(variantId);
    if (!variant) return;

    var currentPrice = variant.price;
    var promoCents = calculatePromo(productData.id, currentPrice);
    if (promoCents <= 0) return;

    var fakeComparePrice = currentPrice + promoCents;
    var promoEuros = Math.floor(promoCents / 100);

    /* Find price container in the parsed HTML */
    var priceWrap = htmlDoc.getElementById('price-' + sectionId);
    if (!priceWrap) return;

    var containers = priceWrap.querySelectorAll('.price');
    containers.forEach(function (c) {
      applyPromoToContainer(c, currentPrice, fakeComparePrice, promoEuros);
    });
  }

  /* ══════════════════════════════════════════════════════
     PATCH renderProductInfo
     Modify the fetched HTML BEFORE inserting into DOM.
     The browser never renders a frame without the promo.
     ══════════════════════════════════════════════════════ */
  function patchVariantRender() {
    function tryPatch() {
      var el = document.querySelector('variant-selects, variant-radios');
      if (!el || !el.renderProductInfo) return false;

      var _original = el.renderProductInfo.bind(el);

      el.renderProductInfo = function () {
        var _this = this;
        var requestedVariantId = this.currentVariant ? this.currentVariant.id : null;
        var sectionId = this.dataset.originalSection || this.dataset.section;

        fetch(
          this.dataset.url + '?variant=' + requestedVariantId +
          '&section_id=' + sectionId
        )
          .then(function (r) { return r.text(); })
          .then(function (responseText) {
            if (_this.currentVariant && _this.currentVariant.id !== requestedVariantId) return;

            var html = new DOMParser().parseFromString(responseText, 'text/html');

            /* ★ APPLY PROMO TO PARSED HTML BEFORE INJECTION ★ */
            applyPromoToHtml(html, sectionId, requestedVariantId);

            /* Now inject the already-promo'd HTML into the live DOM */
            var destination = document.getElementById('price-' + _this.dataset.section);
            var source = html.getElementById('price-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;

            /* Handle all other elements exactly like the original */
            var skuSrc = html.getElementById('Sku-' + sectionId);
            var skuDst = document.getElementById('Sku-' + _this.dataset.section);
            var invSrc = html.getElementById('Inventory-' + sectionId);
            var invDst = document.getElementById('Inventory-' + _this.dataset.section);
            var volSrc = html.getElementById('Volume-' + sectionId);
            var volDst = document.getElementById('Volume-' + _this.dataset.section);
            var ppiSrc = html.getElementById('Price-Per-Item-' + sectionId);
            var ppiDst = document.getElementById('Price-Per-Item-' + _this.dataset.section);
            var qtyRules = document.getElementById('Quantity-Rules-' + _this.dataset.section);
            var volNote = document.getElementById('Volume-Note-' + _this.dataset.section);

            if (volNote) volNote.classList.remove('hidden');
            if (volDst) volDst.classList.remove('hidden');
            if (qtyRules) qtyRules.classList.remove('hidden');
            if (invSrc && invDst) invDst.innerHTML = invSrc.innerHTML;
            if (skuSrc && skuDst) {
              skuDst.innerHTML = skuSrc.innerHTML;
              skuDst.classList.toggle('hidden', skuSrc.classList.contains('hidden'));
            }
            if (volSrc && volDst) volDst.innerHTML = volSrc.innerHTML;
            if (ppiSrc && ppiDst) {
              ppiDst.innerHTML = ppiSrc.innerHTML;
              ppiDst.classList.toggle('hidden', ppiSrc.classList.contains('hidden'));
            }

            var priceEl = document.getElementById('price-' + _this.dataset.section);
            if (priceEl) priceEl.classList.remove('hidden');
            if (invDst) invDst.classList.toggle('hidden', invSrc && invSrc.innerText === '');

            /* Button state */
            var addBtn = html.getElementById('ProductSubmitButton-' + sectionId);
            _this.toggleAddButton(
              addBtn ? addBtn.hasAttribute('disabled') : true,
              window.variantStrings.soldOut
            );

            /* Publish variant change event */
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html: html,
                variant: _this.currentVariant,
              },
            });
          });
      };
      return true;
    }

    if (!tryPatch()) {
      var attempts = 0;
      var iv = setInterval(function () {
        if (tryPatch() || ++attempts > 30) clearInterval(iv);
      }, 200);
    }
  }

  /* ── INIT ── */
  function init() {
    fetchProductData().then(function () {
      applyPromo();
      patchVariantRender();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
